import React from 'react';
import * as css from './WhatsAppImage.css';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {defaultImage} from '../../../assets/symbols/images/defaultImage';
import EyeHideSection from '../../components/eyeHideSection/EyeHideSection';
import ConvertDecimalToHex from '../../../functions/ConvertDecimalToHex';
import {givechakImage} from '../../../assets/symbols/images/givechakImage';
import ExternalImagePopup from '../../../component/imagePopup/externalImagePopup/ExternalImagePopup';
import ConditionalWrapper from '../../../component/conditionalWrapper/ConditionalWrapper';
import {validateWhatsAppImage, isImagePathSupported} from './whatsAppValidation';

function WhatsAppImage({name = 'whatsappImage', eyeName = '', image, saveImage}) {
    const {t} = useTranslation('branding');
    const {currentLang} = useSelector(s => s.branding??{});
    const {colorMain} = useSelector(s => s.branding.data?.[currentLang]??{});
    const hexColor = colorMain && ConvertDecimalToHex(colorMain);
    const {type} = useSelector(s => s.event);

    let fbImg = useSelector(s => s.event.fbImg);
    if(fbImg === defaultImage && type=== 'givechak'){
        fbImg = givechakImage;
    }
    const widthWindowWidth=useSelector(s=>s.ui.windowWidth);
    const imageHeight=Math.min(parseInt((widthWindowWidth-20)/3.94),200);

    // For givechak events, use givechak default image if current image is not supported
    const getDefaultImage = () => {
        if(type === 'givechak') {
            return (image?.path && isImagePathSupported(image.path))
                ? image.path
                : givechakImage;
        }
        return image?.path || defaultImage;
    };
    const imageEditorProps = {
        size: {width: Math.min(630,widthWindowWidth-90), height:imageHeight},
        image: getDefaultImage(),
        imageId: image?.imageId,
        setImage: (image) => saveImage(image),
        type: 'image/jpeg',
        limitMB: 5,
        skipEditor: true, // Skip editor to avoid cropping - upload full image
        validateImage: (file) => validateWhatsAppImage(file, t)
    };
    const creditProps = {
        creditName: image?.creditName,
        alt: image?.alt,
        license: image?.license,
    };

    return (
        <css.wrapWhatsappImage>
            <css.wrapTitle>
                <css.whatsappImageTitle>{t('whatsappImage')}</css.whatsappImageTitle>
            </css.wrapTitle>
            <ConditionalWrapper
                condition={!!eyeName} wrapper={children => <EyeHideSection sectionName={eyeName}>{children}</EyeHideSection>}>
                <css.whatsappImage color={hexColor} height={`${imageHeight}px`} data-cy={`${name}Image`}>
                    {!image && <css.image className={type} image={fbImg|| (type=== 'givechak' ? givechakImage : defaultImage)}/>}
                    <ExternalImagePopup imageProps={imageEditorProps} creditProps={creditProps} absoluteImage={!image}/>
                    <css.uploadIcon/>
                </css.whatsappImage>
            </ConditionalWrapper>
        </css.wrapWhatsappImage>
    );
}

export default WhatsAppImage;
